module.exports = __webpack_public_path__ + "img/SHBK.f2ba1ea8.png";